export enum StateSwitchActions {
    ADD,
    SET,
}
